import styled from 'styled-components';
import { Input, Tooltip } from '@heroui/react';
import {
  black,
  lightGray2,
  raisinBlack,
  TipsHeadingColor,
  AddColor,
} from '@styling/theme';
import breakpointsMinWidth from '@styling/breakpointsMinWidth';
import scrollBar from '../../../../../../UI/Editor/shared/scrollBar';

export const SearchInputWrapper = styled.div`
  position: relative;
  background-color: white;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: ${black};
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;
export const RightSideWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionTitle = styled.span`
  margin-left: 6px;
  margin: ${(props) => !props.IconComponent && '0'};
  color: ${black};
  font-weight: 400;
  line-height: normal;
`;

export const HeadingWrapper = styled.div`
  padding-left: 1px;
`;
export const SubHeadingWrapper = styled.div`
  padding-left: 24px;
`;

export const StyledHeading = styled.h1`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${TipsHeadingColor};
  padding-left: 1px;
  margin-bottom: 10px;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;

export const StyledSubHeading = styled.h2`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;
export const ParagraphWrapper = styled.div`
  padding-left: 18px;
`;

export const StyledParagraph = styled.p`
  font-weight: 300;
  font-size: 13px;
  line-height: 24px;
  color: ${raisinBlack};
  margin-bottom: 10px;
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 14px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;

export const ListWrapper = styled.div`
  padding-left: 48px;
`;

export const SubListWrapper = styled.div`
  padding-left: 70px;
`;

export const ListItem = styled.li`
  font-weight: 300;
  font-size: 13px;
  line-height: 24px;
  color: ${black};
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 14px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;

export const SubListItem = styled.li`
  font-weight: 300;
  font-size: 13px;
  line-height: 24px;
  color: ${black};
  list-style-type: circle;
  padding-bottom: 2px;
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 14px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;

export const ContentWrapper = styled.div`
  padding-top: 4px;
`;

export const MainWrapper = styled.div`
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
`;

export const SearchInput = styled(Input)`
  width: 260px;
  height: 40px;
  font-size: 14px;
  box-shadow: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;

export const CustomTooltipWrapper = styled(Tooltip)`
  color: white;
  background-color: ${black};
`;

export const TooltipWrapper = styled.div`
  max-width: 220px;
  white-space: normal;
  word-wrap: break-word;
`;
export const TooltipContentWrapper = styled.p`
  margin-bottom: 0px !important;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TipsPadWrapper = styled.div`
  ${(props) =>
    scrollBar({
      width: '6px',
      height: '6px',
      isFullscreen: props.isFullscreen,
    })}
  grid-column: 1/7;
  grid-row: 1/1;
  display: ${(props) => (props.tipsPad ? 'block' : 'none')};
  width: 100%;
  color: rgba(59, 69, 78, 1);
  text-align: left;
  box-sizing: border-box;
  background: white;
  padding: 0px;
  border: 1px solid ${lightGray2};
  position: relative;
  overflow-y: overlay;
  overflow-x: hidden;
  height: ${(props) =>
    !props.isFullscreen
      ? `calc(100vh - (40px + 0px + ${!props.menuBar ? '0px' : '40px'} + 24px))`
      : `calc(100vh - (40px + ${!props.menuBar ? '0px' : '44px'} + 24px))`};

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 1/-1;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 7/-1;
    display: ${(props) => (props.tipsPad ? 'flex' : 'none')};
    flex-direction: column;
  }
`;
export const DropdownWrapper = styled.div``;

export const DisclaimerWrapper = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  background-color: white;
  border-top: 0;
  height: 18px;
  border-bottom: 1px solid ${lightGray2};
`;
export const DisclaimerTextWrapper = styled.div`
  font-size: 10px;
  padding: 2px;
  color: ${AddColor};
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  background-color: transparent;
  box-shadow: 0px 0px 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 24px;
  width: 24px !important;
  align-items: center;
  justify-content: center;
  display: flex;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;
